import Icon from '../Icon.vue'

Icon.register({
  'csv': {
    width: 20,
    height: 20,
    paths: [
      {
        d: 'M10 5V2.824L12.176 5H10zm.003-5H1a1 1 0 00-1 1v18a1 1 0 001 1h13a1 1 0 001-1v-3h-2v2H2V2h6v4a1 1 0 001 1h4v2h2V4.997L10.003 0z'
      },
      {
        d: 'M9.61 15.055c-.58 0-1.022-.196-1.387-.561-.525-.525-.504-1.225-.504-1.974 0-.75-.02-1.45.504-1.976.365-.364.806-.56 1.387-.56.945 0 1.71.525 1.891 1.625h-1.246c-.078-.28-.232-.533-.638-.533-.224 0-.392.092-.484.21-.11.148-.188.323-.188 1.234 0 .91.077 1.085.188 1.232.092.119.26.21.484.21.406 0 .56-.252.638-.532h1.246c-.182 1.1-.946 1.625-1.89 1.625zM13.705 15.055c-.764 0-1.387-.14-1.89-.658l.784-.784c.258.258.713.349 1.113.349.483 0 .715-.161.715-.448a.417.417 0 00-.099-.294c-.062-.063-.168-.112-.329-.133l-.603-.084c-.44-.063-.777-.21-1-.441-.232-.238-.344-.574-.344-1.002 0-.91.686-1.575 1.821-1.575.715 0 1.254.168 1.681.594l-.77.77c-.315-.315-.728-.293-.946-.293-.427 0-.603.245-.603.462a.33.33 0 00.1.23.563.563 0 00.342.149l.602.084c.448.062.771.203.981.413.266.259.371.63.371 1.093 0 1.014-.875 1.568-1.926 1.568zM18.347 15.013h-.91l-1.647-4.986h1.268l.84 2.787.827-2.787H20l-1.653 4.986z'
      }
    ]
  }
})
